const toolbar = 64;
const titleBar = 102;
const padding = 32;
const tabHeight = 54;

class dataStore {
	env: string;

	ownerInformation: { id: string; email: string; name: string; img: string } = {
		id: "",
		email: "",
		name: "",
		img: "",
	};
    billableItemsOptions: any = {
		hoa:[],
		property:[],
		municipality:[]
    }
	responsiveWidthOfMainDashboard: number;

	notVisibleItemOfOverview:any = {};
	notVisibleItemOfProcedure:any = {};
	notVisibleItemOfViolation:any = {};
	notVisibleItemOfViolationTab:any = {};

	selectedConfiguration:any = {};

	lastPageStatus: any = {
		Municipality: false,
		Hoa: false,
		Property: false,
		Mail: false,
		Requests: false,
		Document: false
	};

	responsiveHeight = toolbar + titleBar + padding;
	responsiveHeightWithtab = toolbar + titleBar + padding + tabHeight;

	createdLogs: any = [];

	userRole: string = "";
	organizations: any = [];
	selectedOrganization: any = {};

	changedKeys: any = [];

	public isUserPermitted(tag: string, view: string, options?: string) {
		switch (this.userRole) {
			case "developer":
				return true;
			case "admin":
				return true;
			case "officer":
				if ((tag === "Municipality" || tag === "HOA" || tag === "Hoa" || tag === "Property" || tag === "Invoicing" || tag === "Requests" || tag === "Document" || tag === "Data Field Configurator") && (view === "log_update" || view === "configurator" || options === "delete" || options === "log" || options === "download")) {
					return false;
				}
				return true;
			case "client":
				if ((tag === "Municipality" || tag === "HOA" || tag === "Hoa" || tag === "Property" || tag === "Invoicing" || tag === "Requests" || tag === "Document") && ( view === "add" || view === "update" || view === "log_update" || options === "delete" || options === "log" || options === "download")) {
					return false;
				}
				return true;
			case "organization-user":
				if ((tag === "Municipality" || tag === "HOA" || tag === "Hoa" || tag === "Property" || tag === "Invoicing" || tag === "Requests" || tag === "Document") && ( view === "add" || view === "update" || view === "log_update" || options === "delete" || options === "log" || options === "download" || options === "HOA_ONBOARDING")) {
					return false;
				}
				return true;
			case "css":
				if ((tag === "Municipality" || tag === "HOA" || tag === "Hoa" || tag === "Property" || tag === "Invoicing" || tag === "Requests" || tag === "Document") && (options === "delete" || options === "log" || options === "download")) {
					return false;
				}
				return true;
			case "unknown":
				if ((tag === "Municipality" || tag === "HOA" || tag === "Hoa" || tag === "Property" || tag === "Invoicing" || tag === "Requests" || tag === "Document") && (view === "view" || view === "add" || view === "update"  || options === "delete" || options === "log" || options === "download")) {
					return false;
				}
				return true;
			default:
				return true;
		}
	}

	public getIdFromUrl(){
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get("id");
	}

	private propertyEditingStartTime:any;
	private propertyEditingEndTime:any;

	public setStartTime() {
		this.propertyEditingStartTime = new Date()
		this.propertyEditingEndTime = null;
	}

	public endStartTime() {
		this.propertyEditingEndTime = new Date()
	}

	public getTimeOfVerified() {
		return {
			startTime : this.propertyEditingStartTime,
			endTime: this.propertyEditingEndTime
		}
	}
}

export default new dataStore();
